var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1V7M10 1C9.621 1 9.315 1.35 8.705 2.048L7 4M10 1C10.38 1 10.684 1.35 11.295 2.048L13 4M1 10H7M1 10C1 10.379 1.35 10.685 2.048 11.295L4 13M1 10C1 9.62 1.35 9.316 2.048 8.705L4 7M19 10H13M19 10C19 9.621 18.65 9.315 17.952 8.705L16 7M19 10C19 10.38 18.65 10.684 17.952 11.295L16 13M10 19V12.5M10 19C10.379 19 10.685 18.65 11.295 17.952L13 16M10 19C9.62 19 9.316 18.65 8.705 17.952L7 16",
    stroke: "#C8BEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni1);
export default __webpack_public_path__ + "static/media/Ani1.8fd49fa65ce21f0331df181a1c4daae0.svg";
export { ForwardRef as ReactComponent };